import request from '@/request/request'

/**
 *  阿里云图形验证注册模块发送验证码业务
 * @param {} parameter 
 * @returns 
 */
export function aliyunPhotoCaptchaRegister (parameter) {
  return request({
    url: '/external-service-center/aliyunPhotoCaptcha/registerSendSms',
    method: 'post',
    data: parameter
  })
}

/**
 *  验证手机号是否重复
 * @param {} parameter 
 * @returns 
 */
export function validateDuplicateRegister (parameter) {
  return request({
    url: '/e-find-user/testRegister/validateDuplicateRegister',
    method: 'post',
    data: parameter
  })
}

/**
 *  阿里云图形验证注册模块发送验证码业务
 * @param {} parameter 
 * @returns 
 */
export function registerUser (parameter) {
  return request({
    url: '/e-find-user/testRegister/registerUser',
    method: 'post',
    data: parameter
  })
}